import {MM_QUESTION, QUESTION_INPUT_TYPE} from "../../scripts/myga-model";
import QuestionTextArea from "./QuestionTextArea";
import React, {useCallback} from "react";
import QuestionRadio from "./QuestionRadio";
import QuestionMultiCheckbox from "./QuestionMultiCheckbox";
import QuestionTextField from "./QuestionTextField";
import QuestionSelect from "./QuestionSelect";
import QuestionLayout from "./QuestionLayout";
import {isArray, regex} from "../../scripts/myga-utils";
import QuestionDatePicker from "./QuestionDatePicker";
import QuestionTimePicker from "./QuestionTimePicker";
import {validateCondition} from "../../scripts/validation";
import QuestionCurrency from "./QuestionCurrency";
import QuestionCheckbox from "./QuestionCheckbox";
// import QuestionRadioCheckbox from "./QuestionRadioCheckbox";
import {PROCESS_COL_WIDTH} from "../../scripts/layout-manager";
import useWindowWidthResize from "../../scripts/UseWindowWidthResize";
import {isValid} from "../../scripts/myga-session";
import GENERATOR from "../../selenium-front-end/generator/Generator";

export default function Question(props) {
  const {containerClass, questionClass, textClass, responseClass, question, onChange, data} = props;

  const handleTesting = async (field, e, value) => {
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      await GENERATOR.handleTestEvent(field, e, value)
    }
  }

  const handleChange = useCallback((field) => async (e) => {
    let value =  e.target && e.target.value!==undefined ? e.target.value : e;
    await handleTesting(field, e, value)
    onChange(field)(value);
  },[onChange]);

  const handleClick = useCallback((field) => async (e) => {
    const value =  e.target && e.target.checked!==undefined ? !e.target.checked ? 'No' : 'Yes' : e;
    await handleTesting(field, e, value)
    onChange(field)(value);
  },[onChange]);

  const handleRequired = cond => validateCondition(cond, data);
  const requirementConditions = question.requirementConditions ? question.requirementConditions : [];
  const required = (() => {
    if (!isArray(requirementConditions)) return requirementConditions === true;
    if (requirementConditions.length === 0) return false;
    let cond;
    let isRequired = false;
    for (let i=0; i<requirementConditions.length; i++) {
      cond = requirementConditions[i];
      isRequired = handleRequired(cond,data);
      if (isRequired) i=requirementConditions.length;
    }
    return isRequired;
  })();

  let combinedResponseClass = isValid(responseClass) ? `${responseClass} ` : '';
  if (question.response?.className) {
    combinedResponseClass = combinedResponseClass.concat(question.response.className,' ');
  }
  if (question.response?.colSpan) {
    combinedResponseClass = combinedResponseClass.concat(PROCESS_COL_WIDTH(question.response.colSpan));
  }

  let childrenClass = '';

  const component = (() => {
    switch (question[MM_QUESTION.inputType]) {
      case QUESTION_INPUT_TYPE.textArea:
        return <QuestionTextArea data={data}
                                 handleChange={handleChange}
                                 required={required}
                                 question={question}
                                 responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.text:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  required={required}
                                  question={question}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.email:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'email'}
                                  pattern={regex.email}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.phone:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'tel'}
                                  pattern={regex.phoneNumberUS}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.ssn:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.ssn}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.zip:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.zip}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.referralCode:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  pattern={regex.referralCode}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.idNumber:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.idNumber}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.bankRoutingNumber:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.bankRoutingNumber}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.bankAccountNumber:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.bankAccountNumber}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.currency:
        return <QuestionCurrency data={data}
                                 handleChange={handleChange}
                                 question={question}
                                 required={required}
                                 inputMode={'numeric'}
                                 responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.integer:
        return <QuestionTextField data={data}
                                  handleChange={handleChange}
                                  question={question}
                                  required={required}
                                  inputMode={'numeric'}
                                  pattern={regex.numbers}
                                  responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.select:
        return <QuestionSelect data={data}
                               handleChange={handleChange}
                               required={required}
                               question={question}
                               responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.radio:
        return <QuestionRadio data={data}
                              handleChange={handleChange}
                              required={required}
                              question={question}
                              responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.radioCheckbox:
        childrenClass = 'multiCheckboxChildren';
        return <QuestionMultiCheckbox data={data}
                                      mode={'radio'}
                                      handleChange={handleChange}
                                      handleClick={handleClick}
                                      required={required}
                                      question={question}
                                      responseClass={combinedResponseClass}/>
        // return <QuestionRadioCheckbox data={data}
        //                               handleChange={handleChange}
        //                               handleClick={handleClick}
        //                               required={required}
        //                               question={question}
        //                               responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.checkbox:
        return <QuestionCheckbox data={data}
                                 handleChange={handleChange}
                                 handleClick={handleClick}
                                 required={required}
                                 question={question}
                                 responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.multiCheckbox:
        childrenClass = 'multiCheckboxChildren';
        return <QuestionMultiCheckbox data={data}
                                      handleChange={handleChange}
                                      handleClick={handleClick}
                                      required={required}
                                      question={question}
                                      responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.date:
        return <QuestionDatePicker data={data}
                                   handleChange={handleChange}
                                   required={required}
                                   question={question}
                                   responseClass={combinedResponseClass}/>
      case QUESTION_INPUT_TYPE.time:
        return <QuestionTimePicker data={data}
                                   handleChange={handleChange}
                                   required={required}
                                   question={question}
                                   responseClass={combinedResponseClass}/>
      default:
        return ''
    }
  })();

  const labelTextSpan = useWindowWidthResize(() => question.label?.colSpan ? PROCESS_COL_WIDTH(question.label.colSpan) : '');
  return (
    <QuestionLayout question={question}
                    containerClass={containerClass}
                    questionClass={`${questionClass} ${labelTextSpan}`}
                    textClass={textClass}
                    childrenClass={`${childrenClass}`}
                    handleChange={handleChange}
                    data={data}>
      {component}
    </QuestionLayout>
  )
}